import { useEffect } from "react";

const AuthRedirectCleaner = () => {
      useEffect(() => {
        if (window.location.search.includes("code=")) {
        window.history.replaceState(null, "", "/homepage");
    }
      }, []);

    return null;
};
export default AuthRedirectCleaner;